import template from './client-list.html';
import controller from './client-list.controller';

let clientListComponent = {
  bindings: {},
  template,
  controller
};

export default clientListComponent;



// WEBPACK FOOTER //
// ./client/app/components/client/client-list.component.js